import UploadDocumentos from './uploadDocumentos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    listDocumentosSolicitadosAction,
    enviarArquivos
} from '../../store/uploadDocumentos/actions';

const mapStateToProps = (state, nextState) => ({
    uploadDocumentos: state.uploadDocumentosReducer,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        listDocumentosSolicitadosAction,
        enviarArquivos
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadDocumentos);